<script setup lang="ts">
import _debounce from 'lodash/debounce'
import SearchBox from 'frontcore/views/search/SearchBox.vue'
import useRemoteFiltersStore from 'frontcore/presentation/remote-filters/data/use-remote-filters-store'
import { computed } from 'vue'
import {
  RemoteFiltersFieldType,
  RemoteFiltersStoreConfiguration,
} from 'frontcore/presentation/remote-filters/domain/types'

type Props = {
  filterURL: string
  storeConfiguration?: RemoteFiltersStoreConfiguration
}
const props = defineProps<Props>()

const SEARCH_DELAY_MS = 750

const filtersStore = useRemoteFiltersStore(props.filterURL, props.storeConfiguration)

const hasSearchFilter = computed<boolean>(() => {
  return filtersStore.moduleRemoteFiltersConfigurations.some(filter => filter.filterType === RemoteFiltersFieldType.SEARCH)
})

const updateSearchText = _debounce((newSearchText?: string) => {
  filtersStore.searchText = newSearchText ?? ''
}, SEARCH_DELAY_MS)

</script>

<template>
  <SearchBox
    v-if="hasSearchFilter"
    :value="filtersStore.searchText"
    data-test="core-filter-search-box"
    @input="updateSearchText" />
</template>
